import { Image as AntdImage, Typography } from 'antd';
import styled from 'styled-components';

export const Image = styled(AntdImage)`
  .ant-image {
    margin-right: var(--layout-01);
  }
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: inline-flex;
  align-items: center;

  svg,
  .ant-image {
    margin-right: var(--spacing-03);
    flex-shrink: 0;
    color: var(--blue-60);

    &-img {
      display: block;
    }
  }
`;

export const Container = styled.span`
  width: calc(100% - var(--spacing-05));

  .add-button,
  .more-actions {
    opacity: 0;
    transition: opacity 50ms ease-in;
  }
  .add-button:focus-within,
  .more-actions:focus-within {
    opacity: 1;
  }

  a {
    width: 100%;
  }

  &:hover {
    .add-button,
    .more-actions {
      opacity: 1;
    }
  }
`;

export const Title = styled(Typography.Text)`
  width: 144px;
`;
